import { Component, inject } from '@angular/core';
import { PurchaseOrderDetailService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PurchaseOrderDetailCreateDto,
  PurchaseOrderDetailDto,
  PurchaseOrderDetailExcelDownloadDto,
  PurchaseOrderDetailUpdateDto,
} from '../proxy/controlling/dtos/purchase-order-detail';
import { PURCHASEORDERDETAIL_CONFIG, PURCHASEORDERDETAIL_FIELDS } from './purchase-order-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-purchase-order-detail',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm
],
  providers: [ListService, PurchaseOrderDetailService, ConfirmationService],
  templateUrl: './purchase-order-detail.html',
  styleUrl: './purchase-order-detail.scss',
})
export class PurchaseOrderDetail extends BaseHierarchicalCrudComponent<
  PurchaseOrderDetailDto,
  PurchaseOrderDetailCreateDto,
  PurchaseOrderDetailUpdateDto,
  PurchaseOrderDetailExcelDownloadDto
> {
  service = inject(PurchaseOrderDetailService);
  config = PURCHASEORDERDETAIL_CONFIG;
  fields = PURCHASEORDERDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: PurchaseOrderDetailDto): PurchaseOrderDetailUpdateDto {
    return {
      lineItem: data.lineItem,
      consumableId: data.consumableId,
      quantity: data.quantity,
      price: data.price,
      materialType: data.materialType,
      materialGroup: data.materialGroup,
      materialCode: data.materialCode,
      shortText: data.shortText,
      serviceMasterId: data.serviceMasterId,
      status: data.status,
      deliveryDate: data.deliveryDate,
      balance: data.balance,
      depositLocationId: data.depositLocationId,
      purchaseOrderId: data.purchaseOrderId,
      storageLocationId: data.storageLocationId,
      sapPlantId: data.sapPlantId,
      unitOfMeasureId: data.unitOfMeasureId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PurchaseOrderDetail';
  }
}
